  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { DialogProvider, DialogSurfaceProvider } from '../../contexts';
/**
 * Render the final JSX of Dialog
 */ export const renderDialog_unstable = (state, contextValues)=>{
    const { content, trigger } = state;
    return /*#__PURE__*/ _jsx(DialogProvider, {
        value: contextValues.dialog,
        children: /*#__PURE__*/ _jsxs(DialogSurfaceProvider, {
            value: contextValues.dialogSurface,
            children: [
                trigger,
                content
            ]
        })
    });
};
